import { Brand } from "@hubcapp/types";

export const getBrandRoute = (
  brands: Brand[] | string | null,
): "aa" | "bsm" => {
  if (!brands) {
    return "aa";
  }
  if (typeof brands === "string") {
    return brands.toLowerCase().includes("bsm") ? "bsm" : "aa";
  }
  return brands.includes(Brand.Aads) ? "aa" : "bsm";
};
